var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('DESP-GERAIS-DEMAN-01') && _vm.statusAprovacao)?_c('b-button',{staticClass:"ml-2",attrs:{"variant":"danger"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarReprovacao()}}},[_c('span',[_c('i',{staticClass:"fa fa-times-circle mr-2"}),_vm._v(" Reprovar ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }